<template>

  <div v-if="showNewUi" class="mb-3">

    <!--   apple pay button  -->
    <div v-if="applePay" class="p-3 border border-2 border-dark d-flex flex-row" style="border-radius: 1rem"  @click="selectPayByGoogleOrApple(6)">
      <div style="margin-top: -0.7rem">
        <div class="new-custom-checkbox mt-4 mr-2" :class="selectedPaymentMethod ===6 && 'bg-black'"></div>
      </div>

      <div class="d-flex">
        <img alt="credit card icon" src="../../../../assets/newUi/icons/apple.png"/>
        <span class="ml-3 pt-2">Apple Pay</span>
      </div>
    </div>


    <!--    google pay button -->
    <div v-if="googlePay" class="p-3 border border-2 border-dark d-flex flex-row" :class="applePay && 'mt-3' " style="border-radius: 1rem"  @click="selectPayByGoogleOrApple(7)">
      <div style="margin-top: -0.9rem">
        <div class="new-custom-checkbox mt-4 mr-2" :class="selectedPaymentMethod ===7 && 'bg-black'"></div>
      </div>

      <div class="d-flex">
        <img alt="credit card icon" src="../../../../assets/newUi/icons/google.png"/>
        <span class="ml-3" style="padding-top: 0.1rem">Google Pay</span>
      </div>
    </div>

  </div>
  <div v-else>
    <div
        id="payment-request-button"
        :class="disabled ? 'disabled' : 'enabled'"
        class="pt-2 mb-2"
    ></div>
    <div
        v-if="enableCustomButton"
        class="gpay-custom-button"
        @click="showPayment"
    >
      <img src="../../../../assets/Google_Pay_Logo.svg"/>
    </div>
    <div style="color: red">{{ error }}</div>
  </div>
</template>

<script>
import {StripePay} from "../../../../api/payment/stripePay";
import {mapGetters} from "vuex";
import {AppConfig} from "./../../../../../AppConfig.js";
// import { $$ } from "./../../../../sharedscripts/OO_jquery";
import {logger} from "../../../../api/Logger";
import { getCurrency, getStoreLocale } from '../../../../api/helpers/storeHelper';

export default {
  data() {
    return {
      showGooglePayBtn: false,
      error: "",
      refernceId: 0,
      stripe: null,
      paymentRequest: null,
      trackingOrder: null,
      applePay: false,
      googlePay: false,
      tokenId: null,
      enableCustomButton: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: null,
    },
    selectedPaymentMethod : {
      type : Number,
      default:  null
    }
  },
  computed: {
    ...mapGetters(["getTotalPrice", "selectedCompany", "showNewUi", "dbuser"]),
    getSelectedPaymentMethod: {
      get() {
        return this.selectedPaymentMethod;
      },
      set(val) {
        this.$emit("setPaymentMethod", val || 1);
      },
    },

  },
  async mounted() {
    const stripeToken = this.selectedCompany && this.selectedCompany.PaymentConfigEnvironment === 'Sandbox' ? AppConfig.stripeTestToken : AppConfig.stripeToken;
    const currency = getCurrency(this.selectedCompany.CurrencyLocaleName);
    const country = getStoreLocale(this.selectedCompany.CurrencyLocaleName);
    // eslint-disable-next-line no-undef
    this.stripe = Stripe(stripeToken);
    this.paymentRequest = this.stripe.paymentRequest({
      country,
      currency,
      total: {
        label: this.selectedCompany.Name,
        amount: parseInt(this.getTotalPrice * 100, 10), // total in cent
      },
      requestPayerName: false,
      requestPayerEmail: false,
    });

    var elements = this.stripe.elements();
    var that = this;
    var prButton = elements.create("paymentRequestButton", {
      paymentRequest: that.paymentRequest,
    });


    // Check the availability of the Payment Request API first.
    const result = await this.paymentRequest.canMakePayment()
    if (result) {
      // if(!DetectMobile.methods.isMobile() && !result.applePay) {
      //   that.enableCustomButton = true;
      // } else {
      //   prButton.mount("#payment-request-button");
      // }
      that.applePay = !!result.applePay;
      that.googlePay = !!result.googlePay;

      // set apple or google pay as default payment if they are available
      if (this.showNewUi) {
        if (that.applePay) {
          this.$emit('setPaymentMethod', 6 || null)
        }
        if (that.googlePay) {
          this.$emit('setPaymentMethod', 7 || null)
        }
      }

      if (!this.showNewUi) {
        prButton.mount("#payment-request-button");
      }
    } else {
      if (document.getElementById("payment-request-button") != null)
        document.getElementById("payment-request-button").style.display =
            "none";
    }

    prButton.on("click", (event) => {
      event.preventDefault();
      this.$emit("stripe-click", this.applePay ? 6 : 7);
    });
    this.beginPayment();
    // if (!this.disabled) {
    //   $$("#payment-request-button").attr("class", "enabled");
    // } else {
    //   $$("#payment-request-button").attr("class", "disabled");
    // }
  },
  methods: {
    setTrackingOrder(trackingOrder) {
      this.trackingOrder = trackingOrder;
    },
    async finalizeAsync(trackingOrder) {
      this.$emit("finalize", trackingOrder);
    },
    paymentMethod(ev) {
      var stripePay = new StripePay({});
      var that = this;
      this.$emit("proccessing", true);
      that.trackingOrder.TrackingOrder.PaymentTransactions[0].RenfrenceNumber =
        that.tokenId;

      stripePay.createOrder(that.trackingOrder).then((customerInfo) => {
        if (customerInfo.data.Success) {
          stripePay
            .createPayment(that.trackingOrder.TrackingOrder)
            .then((stripeDate) => {
              if (stripeDate.data.Success) {
                // Confirm the PaymentIntent without handling potential next actions (yet).
                that.stripe
                  .confirmCardPayment(
                    stripeDate.data.ClientSecret,
                    { payment_method: ev.paymentMethod.id },
                    { handleActions: false }
                  )
                  .then(function (confirmResult) {
                    if (confirmResult.error) {
                      // Report to the browser that the payment failed, prompting it to
                      // re-show the payment interface, or show an error message and close
                      // the payment interface.
                      that.$emit("error", confirmResult.error.message);
                      that.$emit("proccessing", false);
                      ev.complete("fail");
                    } else {
                      // Report to the browser that the confirmation was successful, prompting
                      // it to close the browser payment method collection interface.
                      ev.complete("success");

                      // The payment has succeeded.
                      that.finalizeAsync(that.trackingOrder);
                      // Let Stripe.js handle the rest of the payment flow.
                      if (
                        confirmResult.paymentIntent &&
                        (confirmResult.paymentIntent.status ===
                          "requires_action" ||
                          confirmResult.paymentIntent.status ===
                            "requires_source_action")
                      ) {
                        that.stripe
                          .confirmCardPayment(stripeDate.data.ClientSecret)
                          .then(function (result) {
                            if (result.error) {
                              that.$emit("proccessing", false);
                              that.$emit("error", result.error.message);
                              // The payment failed -- ask your customer for a new payment method.
                            } else {
                              // Report to the browser that the confirmation was successful, prompting
                              // it to close the browser payment method collection interface.
                              ev.complete("success");
                              // The payment has succeeded.
                              that.$emit("finalize", that.trackingOrder);
                            }
                          });
                      }
                    }
                  });
              } else {
                logger.log(
                  "Payment Created failed",
                  `Payment created failed for payment by ${
                    that.applePay ? "Apple" : "Google"
                  }Pay with response => ${JSON.stringify(stripeDate)}`,
                  "GooglePay.vue",
                  logger.LogType.Error
                );
                that.$emit(
                  "error",
                  stripeDate.errMessage && stripeDate.errMessage.Message
                    ? stripeDate.errMessage.Message
                    : "Could not create a payment please try again"
                );
                that.$emit("proccessing", false);
                ev.complete("fail");
              }
            }).catch(
              (err) => {
                logger.log(
                  "Payment Created failed",
                  `Payment created failed for payment by ${
                    that.applePay ? "Apple" : "Google"
                  }Pay with response => ${JSON.stringify(err)}`,
                  "GooglePay.vue",
                  logger.LogType.Error
                );
                that.$emit(
                  "error",
                    err && err.errMessage && err.errMessage.Message
                    ? err.errMessage.Message
                    : "Could not create a payment please try again"
                );
                that.$emit("proccessing", false);
                ev.complete("fail");
              }
            );
        } else {
          logger.log(
            "Order Created failed",
            `Order created failed for payment by ${
              that.applePay ? "Apple" : "Google"
            }Pay with response => ${JSON.stringify(customerInfo)}`,
            "GooglePay.vue",
            logger.LogType.Error
          );

          let message = "Could not create an order please try again";
          if (customerInfo.errMessage && customerInfo.errMessage.Message) {
            message = customerInfo.errMessage.Message;
          }
          if (customerInfo.data.Status && customerInfo.data.Status.Message) {
            message = customerInfo.data.Status.Message;
          }
          that.$emit("error", message);
          that.$emit("proccessing", false);
          ev.complete("fail");
        }
      }).catch((err) => {
        logger.log(
          "Order Created failed",
          `Order created failed for payment by ${
            that.applePay ? "Apple" : "Google"
          }Pay with response => ${JSON.stringify(err)}`,
          "GooglePay.vue",
          logger.LogType.Error
        );
        that.$emit("error", "Could not create an order please try again");
        that.$emit("proccessing", false);
        ev.complete("fail");
      });
    },
    beginPayment() {
      var that = this;

      this.$nextTick(() => {
        this.paymentRequest.removeAllListeners();
        this.paymentRequest.on("token", function (event) {
          that.tokenId = event.token ? event.token.id : null;
        });
        this.paymentRequest.on("cancel", function () {
          // handle cancel event
          that.$emit("proccessing", false);
        });
        this.paymentRequest.on("paymentmethod", this.paymentMethod);
      });
    },
    showPayment() {
      this.$emit('validateOrder')
      setTimeout(() => {
        if (!this.disabled) {
          this.paymentRequest.show();
        }
      }, 100);
    },
    selectPayByGoogleOrApple(checked) {
      this.$emit('setPaymentMethod', Number(checked) || null)
    }
  },
  watch: {
    disabled() {},
  },
};
</script>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.4;
}
.enabled {
  opacity: 1;
}
</style>
